'use strict'

export default class CommonDialogUtils {

	static fixPageScroll() {
		let top = `-${window.scrollY}px`;
		document.body.style.position = 'fixed';
		document.body.style.top = top;
	}

	static releasePageScroll() {
		const body = document.body;
		const scrollY = body.style.top;
		body.style.position = '';
		body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	}
}